import 'ui-core/plugins/drawer/js/drawer';

(function () {
    // Mostly this file was added to do fix som eIOs related issues
    var $body = $('body'); // @fixme: use document element instead of body ...

    var menu = (UX.menu = UX.menu || {});

    menu.init = function () {
        $('.main-nav').each(function (index) {
            menu.menuHeaderMainTitle = $(this).find('.menu-header').text();
            menu.$target = $(this);
            menu.check.viewPort(index);
            menu.responsive(index);
        });
        menu.items = $('.main-nav').find('a, button, input'); //$(".header__nav a, .header__nav button, .header__nav input");
        menu.iosControl(); // this is the only difference between this init function and the generic one (drawer.js in ux3 )
        menu.control();
        menu.additionalControl();
    };

    menu.iosControl = function () {
        if ($('body').hasClass('iOS')) {
            $body.on('click', '.js--open[data-toggle="nav"]', function (e) {
                $(window).scrollTop(menu.offsetY); // scroll to previous scrolling point for IOs devices
            });

            $body.on('click', '[data-toggle="nav"]', function (e) {
                menu.offsetY = $body.data('yoffset') || window.pageYOffset; // get current scrolling point for IOS devices
                $body.data('yoffset', menu.offsetY);
            });
        }
    };

    menu.on.hideNested = function (shouldNavigate = false) {
        var $menuHeader = $('.menu-header');
        var $parenNestedMenu;

        if (typeof menu.nestedMenu != 'undefined') {
            menu.on.listPosition.start('out');
            $parenNestedMenu = menu.nestedMenu.parent().parent(); // first parent list
            menu.nestedMenu = $parenNestedMenu.parent().find('.dropdown__toggle'); // first parent dropdown toggle link

            $parenNestedMenu.find('.sub-menu__opened').removeClass('sub-menu__opened');
            $parenNestedMenu.find('.menu-parent__opened').removeClass('menu-parent__opened');
            $parenNestedMenu.find('.prev-items').removeClass('prev-items');
            if ($parenNestedMenu.is('#menubar')) $("[data-toggle='nav']").removeClass('js--nested-open'); // <-- difference between classic and core

            if ($parenNestedMenu.hasClass('sub-menu__opened')) {
                $menuHeader.find('span').html(menu.nestedMenu.find('span').html());
            } else {
                if (menu.redirectPath && shouldNavigate && !menu.displayedNestedItems) {
                    document.location = menu.redirectPath;
                } else {
                    $menuHeader.html(menu.menuHeaderMainTitle);
                    menu.displayedNestedItems = false;
                }
            }
        } else {
            menu.nestedMenu = $menuHeader;
        }

        menu.on.hideNestedExtra();
    };

    menu.additionalControl = function () {
        $body.on('click', '.js--open[data-toggle="nav"]', function (e) {
            e.preventDefault();
            menu.on.hide(e);
            menu.$target.attr('style', 'display: none !important');
        });
    };
})();
